// SpotBounty display formatters — single source of truth for enum/label rendering.
// Do NOT change stored enum values in the DB; format at render time only.

const EM = "—";

export function formatEnum(value) {
  if (value == null || value === "") return EM;
  const s = String(value);
  return s.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

export function formatBool(value) {
  if (value == null) return EM;
  return value ? "Yes" : "No";
}

export function formatNumber(value, suffix = "") {
  if (value == null || value === "") return EM;
  return `${value}${suffix}`;
}

export function formatArray(arr) {
  if (!arr || arr.length === 0) return EM;
  return arr.map(formatEnum).join(", ");
}

export function formatDollars(cents) {
  if (cents == null) return EM;
  return `$${(cents / 100).toFixed(2)}`;
}

export const OPERATOR_REQUEST_STATUS_LABELS = {
  pending: "Request Submitted",
  approved: "Approved — Payment Needed",
  payment_pending: "Approved — Payment Needed",
  paid: "Payment Confirmed — Location Package Ready",
  rejected: "Rejected",
  cancelled: "Cancelled",
  expired: "Expired",
};
export function formatOperatorRequestStatus(v) {
  return OPERATOR_REQUEST_STATUS_LABELS[v] || formatEnum(v);
}

export const PAYMENT_METHOD_LABELS = {
  stripe_invoice: "Stripe Invoice",
  ach_bank_transfer: "ACH — Bank Transfer",
  zelle: "Zelle",
  check: "Check",
  cash: "Cash",
  other: "Other",
};
export function formatPaymentMethod(v) {
  if (!v) return EM;
  return PAYMENT_METHOD_LABELS[v] || formatEnum(v);
}

// Canonical status vocabulary (13 + legacy compat)
export const STATUS_LABELS = {
  draft:               "Draft",
  submitted:           "Submitted",
  more_info_requested: "More Info Requested",
  under_review:        "Under Review",
  manager_interested:  "Manager Interested",
  agreement_pending:   "Agreement Pending",
  agreement_signed:    "Agreement Signed",
  verified:            "Verified",   // NOT "Approved" — canonical
  approved:            "Verified",   // legacy display-time mapping
  marketplace_ready:   "Marketplace Ready",
  sold:                "Sold",
  declined:            "Declined",
  rejected:            "Rejected",
  on_hold:             "On Hold",
  // legacy decision markers
  decision_keep:       "Keep · SpotBounty",
  decision_operator:   "For Operator",
  decision_hold:       "On Hold",
};

export function formatStatus(value) {
  return STATUS_LABELS[value] || formatEnum(value);
}

export function formatFinancialTerm(loc) {
  const fp = loc?.financial_pref;
  if (!fp) return EM;
  const label = formatEnum(fp);
  if (fp === "revenue_share" && loc.requested_commission_pct != null) {
    return `${label} · ${loc.requested_commission_pct}%`;
  }
  if (fp === "fixed_rent" && loc.requested_monthly_amount != null) {
    return `${label} · $${loc.requested_monthly_amount}/mo`;
  }
  return label;
}

export function formatContractTerm(loc) {
  if (loc?.preferred_term_months) return `${loc.preferred_term_months} months`;
  if (loc?.preferred_term_custom) return loc.preferred_term_custom;
  return EM;
}
